var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M473.5 2.6c-3.3.8-9.8 3.3-14.5 5.5l-8.5 4.1-217.8 217.6C-2.3 464.7 9.2 452.7 3.4 469.5c-2.5 7.2-2.8 9.3-2.8 21 0 11.3.4 14 2.7 21 13.6 41.1 58.9 59.3 98 39.4 8.1-4.2 9.9-5.9 198.5-194.3L490 166.5l188.3 188.1c103.5 103.4 190 189.5 192.2 191.1 11.1 8.4 26.2 13.3 41 13.3 36.3 0 65.9-27.8 68.2-64 .8-12.2-1.5-23.1-7.3-35l-4.6-9.5-219.2-219.1L529.5 12.3 521 8.2c-4.7-2.3-11.4-4.8-15-5.7-8.1-1.8-24.5-1.8-32.5.1z"}));
}

ArrowUp.defaultProps = {"version":"1.0","width":"1306.667","height":"746.667","viewBox":"0 0 980 560"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
